import type { ReactNode } from "react";
import type { RailwayPurpose } from "../../railway-query/types";
import { RailwayQueryResults } from "../../railway-query/ui/RailwayQueryResults";
import { useItineraryRailwayView } from "../runtime/useItineraryRailwayView";
import type { ItineraryRailwayViewProps } from "../runtime/useItineraryRailwayView";
import { ItineraryRailwaySearchBar } from "./ItineraryRailwaySearchBar";

type Props = ItineraryRailwayViewProps & {
  selectionNote?: string;
  selectionMode?: "compare";
  origin: ReactNode; destination: ReactNode; queryDisabled: boolean; onDateChange: (date: string) => void; onPurposeChange: (purpose: RailwayPurpose) => void;
};

/** 保留铁路页的查询栏与结果顺序，行程端点只接受结构化车站。 */
export function ItineraryRailwayQueryPanel(props: Props) {
  const runtime = useItineraryRailwayView(props);
  return <div className="railway-query-page itinerary-railway-query">
    <ItineraryRailwaySearchBar {...props} />
    <RailwayQueryResults runtime={runtime} persistent selectionNote={props.selectionNote} selectionMode={props.selectionMode} />
  </div>;
}
